import React from "react";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";

export default function FreeUsersNotAllowed(props) {
    const outletContext = useOutletContext()
    const freeUser = outletContext.user.plan === '0'
    return (
        !freeUser ? <Outlet context={outletContext} /> : <Navigate to="/shared-with-me" />
    );
}